import { Address, ChainKey, makeAddressSync } from "@silo/types";
import { match } from "ts-pattern";

// xGRAIL => GRAIL
const XGRAIL_ADDRESS = makeAddressSync(
  "0x3CAaE25Ee616f2C8E13C74dA0813402eae3F496b"
);
const GRAIL_ADDRESS = makeAddressSync(
  "0x3d9907F9a368ad0a51Be60f7Da3b97cf940982D8"
);
const GRAIL_SYMBOL = "GRAIL";

// goARB => ARB
const goARB_ADDRESS = makeAddressSync(
  "0xC5e16f5009776aB645d6719B72962892428b2ac2"
);
const ARB_ADDRESS = makeAddressSync(
  "0x912CE59144191C1204E64559FE8253a0e49E6548"
);
const ARB_SYMBOL = "ARB";

interface GetPricingTokenParams {
  chainKey: ChainKey;
  rewardTokenAddress: Address;
  rewardTokenSymbol: string;
}

interface PricingToken {
  pricingTokenAddress: Address;
  pricingTokenSymbol: string;
}

export function getPricingToken({
  chainKey,
  rewardTokenAddress,
  rewardTokenSymbol,
}: GetPricingTokenParams): PricingToken {
  return match({ chainKey, rewardTokenAddress })
    .returnType<PricingToken>()
    .with({ chainKey: "arbitrum", rewardTokenAddress: XGRAIL_ADDRESS }, () => ({
      pricingTokenAddress: GRAIL_ADDRESS,
      pricingTokenSymbol: GRAIL_SYMBOL,
    }))
    .with({ chainKey: "arbitrum", rewardTokenAddress: goARB_ADDRESS }, () => ({
      pricingTokenAddress: ARB_ADDRESS,
      pricingTokenSymbol: ARB_SYMBOL,
    }))
    .otherwise(() => ({
      pricingTokenAddress: rewardTokenAddress,
      pricingTokenSymbol: rewardTokenSymbol,
    }));
}
